<app-ai-document-processing-disclaimer
	[matterDocumentType]="matterDocumentType"
></app-ai-document-processing-disclaimer>

<app-container class="mt-5">
	<ng-container *ngIf="!(loading$ | async); else loadingCards">
		<div class="flex flex-col mt-5">
			<app-firm-card
				[name]="fireInsuranceCompany?.name"
				[phone]="fireInsuranceCompany?.phoneNumber"
				[fax]="fireInsuranceCompany?.faxNumber"
				[address]="setAddress(fireInsuranceCompany?.address)"
				[email]="fireInsuranceCompany?.email"
				member="FIRE INSURANCE COMPANY"
				memberType="Business"
				*ngIf="fireInsuranceCompany"
				(dropdown)="fireInsuranceCompanyDropdownOptionSelect($event)"
				[testHook]="testHooks.FireInsuranceCompanyCard"
			>
			</app-firm-card>

			<app-search-fire-insurance-company-input
				*ngIf="!fireInsuranceCompany"
				(onCreate)="toggleFireInsuranceCompanyForm($event)"
				class="w-full"
				(onSelect)="onSelectFireInsuranceCompany($event)"
			></app-search-fire-insurance-company-input>

			<app-create-fire-insurance-company
				[@openClose]
				*ngIf="showFireInsuranceCompanyForm"
				(onCancel)="toggleFireInsuranceCompanyForm()"
				(onCreate)="toggleFireInsuranceCompanyForm($event)"
				[name]="fireInsuranceCompanySearchValue"
			></app-create-fire-insurance-company>
		</div>

		<div class="flex flex-col mt-4" *ngIf="fireInsuranceCompany">
			<app-member-card
				*ngIf="fireInsuranceAgent"
				[firstName]="fireInsuranceAgent?.firstName"
				[lastName]="fireInsuranceAgent?.lastName"
				[email]="fireInsuranceAgent?.email"
				[phone]="fireInsuranceAgent?.phoneNumber"
				member="FIRE INSURANCE AGENT"
				memberType="Agent"
				[hoverShadow]="hoverShadow"
				(dropdown)="fireInsuranceAgentDropdownOptionSelect($event)"
			>
			</app-member-card>

			<app-search-fire-insurance-agent
				*ngIf="!fireInsuranceAgent"
				(onCreateAgent)="toggleFireInsuranceAgentForm($event)"
				class="w-full"
				(onSelectedAgent)="onSelectFireInsuranceAgent($event)"
			>
			</app-search-fire-insurance-agent>

			<div
				class="border border-grey-lighter rounded-xl p-4"
				*ngIf="showFireInsuranceAgentForm"
			>
				<app-create-employee-side-form
					[@openClose]
					label="Add Agent"
					[minify]="true"
					(onSubmit)="onSubmitFireInsuranceAgent($event)"
					(onCancel)="toggleFireInsuranceAgentForm()"
					[name]="fireInsuranceAgentSearchValue"
				>
				</app-create-employee-side-form>
			</div>
		</div>

		<div class="flex flex-col mt-4">
			<app-firm-card
				[name]="fireInsuranceBrokerage?.name"
				[phone]="fireInsuranceBrokerage?.phoneNumber"
				[fax]="fireInsuranceBrokerage?.faxNumber"
				[address]="setAddress(fireInsuranceBrokerage?.address)"
				[email]="fireInsuranceBrokerage?.email"
				member="FIRE INSURANCE BROKERAGE"
				memberType="Business"
				*ngIf="fireInsuranceBrokerage"
				(dropdown)="fireInsuranceBrokerageDropdownOptionSelect($event)"
				[testHook]="testHooks.FireInsuranceBrokerageCard"
			>
			</app-firm-card>

			<app-search-fire-insurance-brokerage-input
				*ngIf="!fireInsuranceBrokerage"
				(onCreate)="toggleFireInsuranceBrokerageForm($event)"
				class="w-full"
				(onSelect)="onSelectFireInsuranceBrokerage($event)"
			></app-search-fire-insurance-brokerage-input>

			<app-create-fire-insurance-brokerage
				[@openClose]
				*ngIf="showFireInsuranceBrokerageForm"
				(onCancel)="toggleFireInsuranceBrokerageForm()"
				(onCreate)="toggleFireInsuranceBrokerageForm($event)"
				[name]="fireInsuranceBrokerageSearchValue"
			></app-create-fire-insurance-brokerage>
		</div>

		<div class="flex flex-col mt-4" *ngIf="fireInsuranceBrokerage">
			<app-member-card
				*ngIf="fireInsuranceBroker"
				[firstName]="fireInsuranceBroker?.firstName"
				[lastName]="fireInsuranceBroker?.lastName"
				[email]="fireInsuranceBroker?.email"
				[phone]="fireInsuranceBroker?.phoneNumber"
				member="FIRE INSURANCE BROKER"
				memberType="Broker"
				[hoverShadow]="hoverShadow"
				(dropdown)="fireInsuranceBrokerDropdownOptionSelect($event)"
			>
			</app-member-card>

			<app-search-fire-insurance-broker
				*ngIf="!fireInsuranceBroker"
				(onCreateBroker)="toggleFireInsuranceBrokerForm($event)"
				class="w-full"
				(onSelectedBroker)="onSelectFireInsuranceBroker($event)"
			></app-search-fire-insurance-broker>

			<div
				class="border border-grey-lighter rounded-xl p-4"
				*ngIf="showFireInsuranceBrokerForm"
			>
				<app-create-employee-side-form
					[@openClose]
					label="Add Broker"
					[minify]="true"
					(onSubmit)="onSubmitFireInsuranceBroker($event)"
					(onCancel)="toggleFireInsuranceBrokerForm()"
					[name]="fireInsuranceBrokerSearchValue"
				>
				</app-create-employee-side-form>
			</div>
		</div>

		<div class="flex mt-6">
			<app-container type="dark" title="Details">
				<div class="flex">
					<div class="flex justify-start flex-1">
						<app-radio-group
							label="Type"
							class="mr-2"
							[items]="policyTypes"
							type="compact"
							[(ngModel)]="type"
							(ngModelChange)="setType(type)"
							[testHook]="testHooks.TypeRadioGroup"
							[labelIcon]="AI_ICON"
							[labelToolTip]="
								(fieldMappings$ | async)?.policyNumber ? AI_TOOLTIP : ''
							"
							[labelIconClasses]="AI_CLASSES"
						></app-radio-group>
					</div>
					<div class="flex flex-1">
						<app-input
							label="Policy or binder number"
							class="ml-2"
							[(ngModel)]="policyNumber"
							(debounce)="setPolicyNumber(policyNumber)"
							[testHook]="testHooks.PolicyOrBinderNumber"
							[labelIcon]="AI_ICON"
							[labelToolTip]="
								(fieldMappings$ | async)?.policyNumber ? AI_TOOLTIP : ''
							"
							[labelIconClasses]="AI_CLASSES"
						></app-input>
					</div>
				</div>
				<div class="flex justify-start mt-4">
					<app-checkbox
						label="Guaranteed replacement coverage"
						[(ngModel)]="guaranteedReplacementCoverage"
						(ngModelChange)="
							setGuaranteedReplacementCoverage(guaranteedReplacementCoverage)
						"
						[testHook]="testHooks.GuaranteedReplacementCoverageCheckbox"
					></app-checkbox>
				</div>
				<div class="w-1/2 mt-4">
					<app-date-picker
						label="Active date"
						class="mr-2"
						[(ngModel)]="activeDate"
						(ngModelChange)="setActiveDate(activeDate)"
						[testHook]="testHooks.ActiveDateDatePicker"
						[labelIcon]="AI_ICON"
						[labelToolTip]="
							(fieldMappings$ | async)?.effectiveDate ? AI_TOOLTIP : ''
						"
						[labelIconClasses]="AI_CLASSES"
					></app-date-picker>
				</div>
				<div class="mt-4 flex">
					<app-date-picker
						label="Expiry date"
						class="mr-2"
						[(ngModel)]="expiryDate"
						(ngModelChange)="setExpiryDate(expiryDate)"
						[testHook]="testHooks.ExpiryDateDatePicker"
						[labelIcon]="AI_ICON"
						[labelToolTip]="
							(fieldMappings$ | async)?.expiryDate ? AI_TOOLTIP : ''
						"
						[labelIconClasses]="AI_CLASSES"
					></app-date-picker>
					<app-input
						label="Coverage amount"
						type="cents"
						class="ml-2"
						[startIcon]="ICON.DOLLAR"
						[(ngModel)]="coverageAmount"
						(debounce)="setCoverageAmount(coverageAmount)"
						[testHook]="testHooks.CoverageAmount"
						[labelIcon]="AI_ICON"
						[labelToolTip]="
							(fieldMappings$ | async)?.coverageAmount ? AI_TOOLTIP : ''
						"
						[labelIconClasses]="AI_CLASSES"
					></app-input>
				</div>

				<h5 class="mt-4 font-bold">Policy details</h5>
				<div class="mt-2 flex justify-start">
					<app-checkbox
						label="Interest of all mortgagees have been noted"
						[(ngModel)]="interestOfVTBNotes"
						(ngModelChange)="setInterestOfVTBNotes(interestOfVTBNotes)"
						[testHook]="testHooks.InterestOfAllMortgageesHaveBeenNotedCheckbox"
					></app-checkbox>
				</div>
			</app-container>
		</div>
	</ng-container>
	<ng-template #loadingCards>
		<ui-skeleton-loader class="w-full mb-4" type="field"></ui-skeleton-loader>
		<ui-skeleton-loader
			class="w-full mb-4"
			type="party-card"
		></ui-skeleton-loader>
		<ui-skeleton-loader class="w-full mb-4" type="field"></ui-skeleton-loader>
		<ui-skeleton-loader
			class="w-full mb-4"
			type="party-card"
		></ui-skeleton-loader>
		<!-- <ui-skeleton-loader type="firm-card" />
		<ui-skeleton-loader class="w-full" type="member-card"></ui-skeleton-loader> -->
		<ui-skeleton-loader class="w-full mb-4" type="input" />
		<ui-skeleton-loader type="row" />
	</ng-template>
</app-container>
